import { ConflictError } from "./conflict-error";

// Thrown when a return is booked for an article that is stocked nowhere. A put-away's destination
// is the article's own shelf — the assigned "articleLocations" row holding the least of it — so an
// article with no assignment at all leaves the leg with nowhere to end.
//
// It is a refusal rather than a fallback on purpose. The alternatives are worse in the same way:
// letting the returner choose puts a warehouse-layout decision in the hands of whoever is
// unloading a truck, and parking the stock in the receiving zone would break the rule that an
// article stands only in a `storage` zone — which is what makes a picking round derivable at all.
// Assigning the location once fixes every future return of that article, which is what makes it
// configuration rather than a bad request, and so a 409.
export class ArticleHasNoWarehouseLocationError extends ConflictError {
	constructor() {
		super("stock.article_has_no_warehouse_location");
		this.name = "ArticleHasNoWarehouseLocationError";
	}
}
